module.exports = __webpack_public_path__ + "img/privacy-ex-1.0fae97a0.png";